"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTestAttributes = exports.buildDataTestProps = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _DocumentedComponent = require("../../types/DocumentedComponent");

var _core = require("@emotion/core");

var buildDataTestProps = function buildDataTestProps(_ref) {
  var dataTestComponent = _ref.dataTestComponent,
      dataTestId = _ref.dataTestId;
  var testComponentProp = !!dataTestComponent ? {
    'data-test-component': dataTestComponent
  } : {};
  var testIdProp = !!dataTestId ? {
    'data-test-id': dataTestId
  } : {};
  return (0, _objectSpread2.default)({}, testComponentProp, testIdProp);
};

exports.buildDataTestProps = buildDataTestProps;

var withTestAttributes = function withTestAttributes(_ref2) {
  var component = _ref2.component,
      id = _ref2.id;
  return function (WrappedComponent) {
    var ComponentWithTestAttributes = (0, _react.forwardRef)(function (_ref3, ref) {
      var _ref3$dataTestCompone = _ref3.dataTestComponent,
          dataTestComponent = _ref3$dataTestCompone === void 0 ? component : _ref3$dataTestCompone,
          _ref3$dataTestId = _ref3.dataTestId,
          dataTestId = _ref3$dataTestId === void 0 ? id : _ref3$dataTestId,
          props = (0, _objectWithoutProperties2.default)(_ref3, ["dataTestComponent", "dataTestId"]);
      var dataTestProps = buildDataTestProps({
        dataTestComponent: dataTestComponent,
        dataTestId: dataTestId
      });
      return (0, _core.jsx)(WrappedComponent, (0, _extends2.default)({}, dataTestProps, props, {
        ref: ref
      }));
    });
    var HoistedComponent = (0, _hoistNonReactStatics.default)(ComponentWithTestAttributes, WrappedComponent);
    var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    ComponentWithTestAttributes.displayName = "withTestAttributes(".concat(displayName, ")");
    var description = (0, _DocumentedComponent.isDocumentedComponent)(WrappedComponent) ? WrappedComponent.documentation.toJSON().description : '';
    var DocumentedComponentWithTestAttributes = (0, _stencilReactDesc.describe)(HoistedComponent).description(description);

    if ((0, _DocumentedComponent.isDocumentedComponent)(WrappedComponent)) {
      DocumentedComponentWithTestAttributes.propTypes = (0, _objectSpread2.default)({}, WrappedComponent.describedPropTypes, {
        dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
      });
    } else if (WrappedComponent.propTypes) {
      HoistedComponent.propTypes = (0, _objectSpread2.default)({}, WrappedComponent.propTypes, {
        dataTestId: _propTypes.default.string
      });
    }

    if (WrappedComponent.defaultProps) {
      HoistedComponent.defaultProps = (0, _objectSpread2.default)({}, WrappedComponent.defaultProps);
    }

    var _ref4 = WrappedComponent,
        withComponent = _ref4.withComponent;

    if (withComponent !== undefined) {
      HoistedComponent.withComponent = function (tag) {
        return withTestAttributes({
          component: component,
          id: id
        })(withComponent(tag));
      };
    }

    return DocumentedComponentWithTestAttributes;
  };
};

exports.withTestAttributes = withTestAttributes;